export const policyScopeOptions = [
    {
        label: "Sub-national",
        value: "SUB_NATIONAL"
    },
    {
        label: "National",
        value: "NATIONAL"
    },
];